import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import React from "react";
import AnimateHeight from "react-animate-height";
import { Link } from "react-router-dom";
import { MenuItem } from "../../types";
interface Props {
    items: MenuItem[];
    onNavigate: () => void;
}

export const MenuItems: React.FC<Props> = ({ items, onNavigate }) => {
    const [openIndex, setOpenIndex] = React.useState<number | undefined>();

    const handleNavigate = () => {
        setOpenIndex(undefined);
        onNavigate();
    };

    return (
        <ul>
            {items.map((item, index) => {
                let content;
                switch (item.type) {
                    case "link":
                        content = (
                            <Link onClick={handleNavigate} to={item.to}>
                                {item.title}
                            </Link>
                        );
                        break;
                    case "dropdown":
                        {
                            const isOpen = openIndex === index;
                            content = (
                                <>
                                    <button
                                        onClick={() => {
                                            if (isOpen) {
                                                setOpenIndex(-1);
                                            } else {
                                                setOpenIndex(index);
                                            }
                                        }}
                                    >
                                        {item.title}
                                        {isOpen ? (
                                            <ExpandLessRoundedIcon />
                                        ) : (
                                            <ExpandMoreRoundedIcon />
                                        )}
                                    </button>
                                    <AnimateHeight height={isOpen ? "auto" : 0}>
                                        <MenuItems
                                            onNavigate={handleNavigate}
                                            items={item.children}
                                        />
                                    </AnimateHeight>
                                </>
                            );
                        }
                        break;
                }
                return <li key={index}>{content}</li>;
            })}
        </ul>
    );
};
